@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */

    --n-icon-size-xs: var(--n-scale-300);
    --n-icon-size-sm: var(--n-scale-400);
    --n-icon-size-md: var(--n-scale-500);
    --n-icon-size-lg: var(--n-scale-600);
    --n-icon-size-xl: var(--n-scale-800);
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  .icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    font-size: 0;
  }

  .svg {
    stroke: inherit;
    fill: inherit;
  }

  .narvar-logoIcon .svg,
  .refundIcon .svg,
  .googleIcon .svg {
    stroke: transparent;
  }

  /* SIZES ------------------------------------------------------------------ */

  .xsSize {
    width: var(--n-icon-size-xs);
    height: var(--n-icon-size-xs);
    stroke-width: 1;
  }

  .smSize {
    width: var(--n-icon-size-sm);
    height: var(--n-icon-size-sm);
    stroke-width: 1.5;
  }

  .mdSize {
    width: var(--n-icon-size-md);
    height: var(--n-icon-size-md);
  }

  .lgSize {
    width: var(--n-icon-size-lg);
    height: var(--n-icon-size-lg);
  }

  .xlSize {
    width: var(--n-icon-size-xl);
    height: var(--n-icon-size-xl);
  }

  .fontSize {
    width: 1.25em;
    height: 1.25em;
    font-size: 1em;
    stroke-width: 1.5;
  }
}
